module.exports = __webpack_public_path__ + "img/badge_rugzak.4f5c61f2.png";